module.exports = __webpack_public_path__ + "img/horizontal_3_7_0.eed0e0aa.png";